/**
 * Reports whether a generation schema declares a polycount field at all.
 *
 * @param {Object} generationModelSchema - The schema driving the generation form.
 * @returns {boolean} True when it has a face_count or target_polycount property.
 */
export function hasPolycountField(generationModelSchema) {
  const properties = generationModelSchema?.input_schema?.properties

  return Boolean(properties?.face_count || properties?.target_polycount)
}
